export const ERROR_MESSAGES = {
  PERMISSION: "You don't have permission to do that.",
  OFFLINE_GET: "You are offline. Data will update automatically when your internet connection is restored.",
  OFFLINE_POST:
    "You are offline. Your changes could not be saved – please try again when you are reconnected.",
  RETRYING_CONNECTIVITY:
    "This is taking longer than expected. Looks like a connection issue – we're retrying automatically.",
  TIMEOUT: "Request timed out. Please try again.",
  NETWORK_UNREACHABLE:
    "Cannot reach the server. It may be down or unreachable.",
  SERVER_GENERIC: "Something went wrong on our end – please try again.",
  LOAD_FAILED: "Failed to load data – please refresh the page.",
  SAVE_FAILED: "Something went wrong saving your data – please try again.",
};
